import Library from '../utility/Library';
import User from '../../User';
import Collectable from './Collectable';

const NILITH_OFFER_STEPS = 10;

export default class Celestial {

	constructor (run, key, notify=true) {

		this.run = run;
		this.model = Library.getSpirit(key);
		this.active = true;
		this.collectables = [];
		this.remainingExp = run.champion.gatheredExp;
		this.initialOfferingExp = this.remainingExp;
		this.offeringSteps = 0;
		this.surrendered = false;
		this.run.usedCelestials = this.run.usedCelestials || [];
		if (!this.run.usedCelestials.includes(this.model.key))
			this.run.usedCelestials.push(this.model.key);
		if (notify) {
			const milestone = User.meetCelestial(this.model.key);
			this.run.notify('newcelestial', this, run, key, milestone);
		}
	}

	get choices () {

		const surrenderDisabled = this.corrupted && !this.nilith;
		let choices = [
			{
				type: "surrender",
				disabled: surrenderDisabled
			}
		]

		if (this.run.floor < this.run.maxFloor)
			choices.push({ type: "dive", disabled: this.surrendered });
		else if (!this.nilith)
			choices.push({ type: "end" });

		return choices;
	}

	get corrupted () {

		return this.run.champion.curses?.some(curse => curse.key === "corruption");
	}

	get devotionRank () {

		return User.data.devotion[this.model.devotion].rank;
	}

	get devotionProgress () {

		return User.data.devotion[this.model.devotion].progress;
	}

	get devotionRequirement () {

		return User.devotionRequirement(this.devotionRank);
	}

	get surrenderAmount () {

		return Math.min(this.remainingExp, Math.ceil(this.devotionRequirement * 0.1));
	}

	get nilith () {

		return this.model.devotion === "maze";
	}

	get offeringProgress () {

		return this.nilith ? this.offeringSteps / NILITH_OFFER_STEPS : 0;
	}

	surrenderToNilith () {

		if (this.offeringSteps >= NILITH_OFFER_STEPS)
			return;
		const stepsRemaining = NILITH_OFFER_STEPS - this.offeringSteps;
		const exp = Math.ceil(this.remainingExp / stepsRemaining);
		if (exp > 0) {
			this.run.champion.loseExp(exp);
			this.remainingExp = Math.max(0, this.remainingExp - exp);
		}
		this.offeringSteps++;
		this.surrendered = true;
		this.run.notify('celestialupgrade', this);
		if (this.offeringSteps >= NILITH_OFFER_STEPS) {
			this.run.convertedExpBonus = (this.run.convertedExpBonus || 0) + Math.ceil(Math.max(0, this.initialOfferingExp) / 2);
			User.rankUpDevotion(this.run.difficultySetting, this.run.champion.model.key || this.run.champion.model, this.model.devotion, true);
			this.run.victory();
		}
	}

	select (type) {

		if (!this.active)
			return;

		switch (type) {
		case "surrender":
			if (this.corrupted && !this.nilith)
				return;
			if (this.nilith) {
				this.surrenderToNilith();
				return;
			}
			if (this.remainingExp <= 0) {
				this.run.victory();
				return;
			}
			const exp = this.surrenderAmount;
			const gatheredExp = this.run.champion.gatheredExp;
			this.run.champion.loseExp(exp);
			const transferredExp = gatheredExp - this.run.champion.gatheredExp;
			if (transferredExp <= 0) {
				this.remainingExp = 0;
				this.run.victory();
				return;
			}
			User.addDevotionExp(this.run.difficultySetting, this.run.champion.model.key || this.run.champion.model, this.model.devotion, transferredExp, true);
			this.remainingExp -= transferredExp;
			this.surrendered = true;
			this.run.notify('celestialupgrade', this);
			if (this.remainingExp <= 0)
				this.run.victory();
			break;
		case "dive":
			if (this.surrendered)
				return;
			this.run.diveIn();
			break;
		case "end":
			if (this.run.floor < this.run.maxFloor || this.nilith)
				return;
			this.run.gameOver();
			break;
		default: break;
		}
	}

	activate () {

		this.active = true;
		this.run.notify('celestialactive', this, true);
	}

	deactivate () {

		this.active = false;
		this.run.notify('celestialactive', this, false);
	}

	generateRelic () {

		let relics = Object.values(Library.relics);
		relics = relics.filter(relic => relic.pool === this.model.key && !this.collectables.some(r => r.value.key === relic.key));
		let relic = Library.upgradeItem(relics[Math.floor(Math.random() * relics.length)], this.run.power);
		let collectable = new Collectable(this.run, "relic", relic);
	  	this.collectables.push(collectable);
	  	User.learn("relics", relic.key);
		this.run.notify('generatecelestialrelic', this, collectable);
	    return relic;
	}

	take (no) {

		if (!this.collectables[no])
			return;

		this.collectables.splice(no, 1)[0].collect();
		this.collectables = [];

		this.run.notify('takecelestialrelic', this, no)
	}

	serialize () {

		return {
			active: this.active,
			remainingExp: this.remainingExp,
			initialOfferingExp: this.initialOfferingExp,
			offeringSteps: this.offeringSteps,
			surrendered: this.surrendered,
			collectables: this.collectables.map(c => c ? c.serialize() : null),
			model: this.model?.key
		}
	}

	static build (run, src) {

		let celestial = new Celestial(run, src.model, false);
		celestial.active = src.active;
		celestial.remainingExp = src.remainingExp ?? run.champion.gatheredExp;
		celestial.initialOfferingExp = src.initialOfferingExp ?? celestial.remainingExp;
		celestial.offeringSteps = src.offeringSteps || 0;
		celestial.surrendered = src.surrendered || false;
		celestial.collectables = src.collectables.map(c => c ? Collectable.build(run, c) : null);
		return celestial;
	}
}
